import { createSlice } from '@reduxjs/toolkit'
import { loading } from '../status'

const initialState = {
  news: {
    items: [],
    status: loading,
  },
  newsOptions: [],
  properties: {
    items: [],
    status: loading,
  },
  propertiesOptions: [],
  rooms: {
    items: [],
    status: loading,
  },
  spas: {
    items: [],
    status: loading,
  },
  restaurants: {
    items: [],
    status: loading,
  },
  members: {
    items: [],
    status: loading,
  },
  options: [
    {
      allMembers: '0',
      pendingMembers: '0',
      properties: '0',
      countries: '0',
      benefits: '0',
      id: 'statistics',
    },
    {
      maxUpload: 25,
      templateId: 93,
      id: 'config',
    },
    {
      id: 'membershipIds',
    },
  ],
  countryOptions: [],
  // protocolOptions: [
  //   {
  //     value: 'appScreen',
  //     label: 'App Screen',
  //   },
  //   {
  //     value: 'external',
  //     label: 'External',
  //   },
  // ],
  filterByOptions: [
    {
      value: 'All',
      label: 'All',
    },
    {
      value: 'Members',
      label: 'Only Selected Members',
    },
    // {
    //   value: 'Properties',
    //   label: 'Properties',
    // },
    {
      value: 'Membership',
      label: 'Membership',
    },
    {
      value: 'Location',
      label: 'Location',
    },
    {
      value: 'PremiumEvents',
      label: 'Premium Events',
    },
  ],
  appScreenOptions: [
    {
      value: 'Dashboard',
      label: 'Dashboard',
    },
    {
      value: 'NewsDetails',
      label: 'NewsDetails',
    },
    {
      value: 'CouponDetails',
      label: 'Benefit/CouponDetails',
    },
    {
      value: 'PropertyDetails',
      label: 'PropertyDetails',
    },
    // {
    //   value: 'InsideProperties',
    //   label: 'InsideProperties',
    // },
    // {
    //   value: 'CardDetails',
    //   label: 'CardDetails',
    // },
  ],
  membershipOptions: [
    { value: 'B', label: 'Black' },
    { value: 'BP', label: 'Black Premium' },
  ],
  couponsLevelOptions: [
    { value: 'B', label: 'B' },
    { value: 'BP', label: 'BP' },
    { value: 'SP', label: 'SP' },
  ],
  couponsTypeOptions: [
    { value: 'Benefit', label: 'Benefit' },
    { value: 'Coupon', label: 'Coupon' },
  ],
  booleanOptions: [
    { value: true, label: 'Yes' },
    { value: false, label: 'No' },
  ],
  couponsCategoryOptions: [
    { value: 'Spa', label: 'Spa' },
    { value: 'Restaurants', label: 'Restaurants' },
    { value: 'Hotel', label: 'Hotel' },
  ],
  couponsYearlyOptions: [
    { value: -1, label: 'Unlimited' },
    // { value: -2, label: 'Eventual' },
    { value: 0, label: 'Zero' },
    { value: 1, label: '1 Time' },
    { value: 2, label: '2 Time' },
    { value: 3, label: '3 Times' },
    { value: 4, label: '4 Times' },
    { value: 6, label: '6 Times' },
    { value: 12, label: '12 Times' },
  ],
  couponsStatusOptions: [
    { value: 'Draft', label: 'Draft' },
    { value: 'Publish', label: 'Publish' },
  ],
  statusOptions: [
    { value: 'Draft', label: 'Draft' },
    // { value: 'Pending', label: 'Pending' },
    { value: 'Publish', label: 'Publish' },
  ],
}

export const cmsSlice = createSlice({
  name: 'cms',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setItems: (state, action) => {
      state[action.payload.table] = {
        items: action.payload.items,
        status: action.payload.status,
      }
    },
    syncOptions: (state, action) => {
      state.options = action.payload.items
    },
    syncNews: (state, action) => {
      state.news = {
        items: action.payload.items,
        status: action.payload.status,
      }
      state.newsOptions = action.payload.items.map((item) => ({
        label: item.title,
        value: item.id,
      }))
    },
    loadProperties: (state, action) => {
      state.properties = {
        items: action.payload.items,
        status: action.payload.status,
      }
      state.propertiesOptions = action.payload.items.map((property) => ({
        label: `${property.name} (${property.id})`,
        value: property.id,
      }))
      state.spas = {
        items: action.payload.items.filter(
          (property) => property.category.includes('Spa') === true && property,
        ),
        status: action.payload.status,
      }
      state.restaurants = {
        items: action.payload.items.filter(
          (property) => property.category.includes('Restaurant') === true && property,
        ),
        status: action.payload.status,
      }
      state.rooms = {
        items: action.payload.items.filter(
          (property) => property.category.includes('Rooms') === true && property,
        ),
        status: action.payload.status,
      }

      const options = []
      action.payload.items.forEach((property) => {
        if (!options.find((p) => p.value === property.iso2)) {
          options.push({ label: property.country, value: property.iso2 })
        }
      })
      // NOTE: india just added for testing purpose
      // options.push({ label: 'India (for Testing only)', value: 'IN' })
      state.countryOptions = options
    },
  },
})

export const cmsAction = cmsSlice.actions

export const selectCms = (state) => state.cms

export default cmsSlice.reducer
